module.exports = __webpack_public_path__ + "static-portal/img/xzz-scgk.f404ae1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/xzz-scgk.jpg
// module id = 0P7B
// module chunks = 4